<template>
  <v-container fluid fill-height  justify-center
      align-center grid-list-xl>
      <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
      <v-flex v-else xs12 sm12 md10 lg5 :class="resize">
        <v-card class="elevation-1">
          <v-toolbar :color="color">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title v-if="!isAgencyDeleted" class="white--text">Agency Details</v-toolbar-title>
            <v-toolbar-title v-else color="red" class="white--text">Agency has been deleted</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="!isAgencyDeleted" icon class="white--text" @click="editAgency(agencyData)" >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-dialog v-if="agencyData.is_provider !== '1' && !isAgencyDeleted" v-model="dialog" persistent max-width="350">
              <v-btn 
              slot="activator"
              flat 
              icon 
              class="white--text">
              <v-icon>delete</v-icon>
            </v-btn>
              <v-card>
                <v-card-title class="headline">Confirm your action</v-card-title>
                <v-card-text>Are you sure you want to delete this agency?<br>This action can not be reverted.</v-card-text>
                <v-card-text>Please enter and confirm your password.</v-card-text>
                <v-form v-model="validAcc" ref="form">
                  <v-container fluid>
                    <v-layout row>
                      <v-flex>
                        <v-text-field
                          name="input-8-1"
                          label="Enter your password"
                          v-model="user.password"
                          min="8"
                          :rules="rules.passwordRules"
                          :append-icon="visibility ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (visibility = !visibility)"
                          :type="visibility ? 'password' : 'text'"
                          counter
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex>
                        <v-text-field
                          name="input-8-1"
                          label="Confirm your password"
                          v-model="user.confirm_password"
                          min="8"
                          :rules="rules.passwordRulesConfirm"
                          :append-icon="visibilityConfirm ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (visibilityConfirm = !visibilityConfirm)"
                          :type="visibilityConfirm ? 'password' : 'text'"
                          counter
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn :color="color" @click.native="closeDialog()">Close</v-btn>
                    <v-btn
                    class="white--text"
                    @click.native="checkPassword(); closeDialog(); "
                      :disabled="!validAcc"
                      color="red"
                    >
                      Confirm
                    </v-btn>
                </v-card-actions>
                  </v-container>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card flat>
            <v-card-media>
              <v-container fluid fill-height>
                <v-layout 
                  justify-center
                  align-center>
                  <v-avatar
                      size="150px"
                      :tile="false"
                    >
                    <img :src="agencyData.logo_url || defaultLogo" alt="avatar">
                  </v-avatar>
                </v-layout>
              </v-container>
            </v-card-media>
            <v-card-text>
              <v-list two-line>
                <v-card-title class="black--text">
                    <div class="display-1">{{ agencyData.company }}  </div>
                  </v-card-title>
                  <v-list-tile v-if="providerAgency">
                    <v-list-tile-action>
                      <v-icon :color="color">account_balance</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ providerAgency }}</v-list-tile-title>
                      <v-list-tile-sub-title>Provider</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider inset v-if="providerAgency"></v-divider>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon :color="color">fingerprint</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ agencyData.id }}</v-list-tile-title>
                      <v-list-tile-sub-title>ID</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon :color="color">work</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ agencyType }}</v-list-tile-title>
                    <v-list-tile-sub-title>Agency Type</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon :color="color">account_box</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ agencyData.first_name }} {{ agencyData.last_name }}</v-list-tile-title>
                    <v-list-tile-sub-title>Contact person</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon :color="color">mail</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{agencyData.email}}</v-list-tile-title>
                    <v-list-tile-sub-title>Email</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon :color="color">location_on</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{agencyData.city}}</v-list-tile-title>
                    <v-list-tile-title>{{agencyData.address}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{agencyData.country}} {{agencyData.zip_code}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon :color="color">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{agencyData.phone}}</v-list-tile-title>
                    <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon :color="color">money</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>$ {{agencyData.balance}}</v-list-tile-title>
                    <v-list-tile-sub-title>Current Balance</v-list-tile-sub-title>
                    <v-btn
                    v-if="!isAgencyDeleted"
                    :color="color"
                    @click="adjustBalance"
                    dark
                    small
                    absolute
                    right
                    fab
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
          <v-toolbar :color="color" v-if="this.agencyData.is_provider === '1'">
            <v-toolbar-title class="white--text">Provided Agencies</v-toolbar-title>
          </v-toolbar>
          <v-card class="elevation-1" v-if="this.agencyData.is_provider === '1'">
            <v-card-title>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-flex>
              <v-data-table
                  v-bind:headers="headers"
                  v-bind:items="providedAgencies"
                  v-bind:search="search"
                  :loading="loading"
                  hide-actions
                >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>
                    <v-layout justify-center
                        align-left>
                        <v-flex>
                          <v-avatar
                                  :tile="false"
                                >
                                <img :src="props.item.logo_url || defaultLogo" alt="avatar">
                            </v-avatar>
                        </v-flex>
                    </v-layout>
                  </td>
                  <td>{{ props.item.company || "something" }}</td>
                  <td>{{ props.item.email }}</td>
                  <td class="text-xs-center">{{ props.item.approved | booleanify}}</td>
                  <td class="text-xs-center">{{ props.item.is_disabled | booleanify}}</td>
                  <td>
                    <v-layout align-center>
                      <v-flex>
                        <v-btn
                          @click="showAgency(props.item)" 
                          small 
                          dark :color="color"
                          >
                          show
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                  <td>
                    <v-layout align-center>
                      <v-flex>
                        <v-btn
                          @click="editAgency(props.item)" 
                          small 
                          dark color="black"
                          >
                          edit
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                  <td>
                    <v-layout align-center>
                      <v-flex>
                        <v-btn
                          @click="removeProvidedAgency(props.item.id)" 
                          small 
                          dark color="error"
                          >
                          remove
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <v-divider></v-divider>
            <v-flex>
              <v-card-title>
                <v-flex xs12 lg4>
                  <v-select
                    :items="agencies"
                      v-model="selectedAgency"
                      label="Select Agency"
                      item-text="company"
                      item-value="id"
                      bottom
                      autocomplete
                  >
                    <template slot="item" slot-scope="data">
                      <template>
                        <v-list-tile-content>
                          <v-list-tile-title>{{data.item.company}} {{data.item.id}}</v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 lg1 class="ml-3">
                  <v-btn
                    @click="addAgency(selectedAgency)" 
                    block 
                    small
                    dark :color="color"
                    >
                    Add Agency
                  </v-btn>
                </v-flex>
              </v-card-title>
            </v-flex>
          </v-card>
      </v-card>
    </v-flex>
    <div row>
      <v-alert
        :color="alert.type"
        icon="check_circle"
        :value="alert.status"
        transition="scale-transition"
      >
        {{ alert.message }}
      </v-alert>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
  components: {
    Spinner
  },
  data() {
    return {
      alert: {
        status: false,
        message: "",
        type: ""
      },
      rules: {
        passwordRules: [
          v => !!v || "Field is required"
        ],
        passwordRulesConfirm: [
          v => !!v || "Field is required",
          v => v == this.user.password || "Password not confirmed"
        ],
      },
      user: {
        password: "",
        confirm_password: ""
      },
      defaultLogo: defaultLogo,
      validAcc: true,
      visibility: true,
      visibilityConfirm: true,
      dataLoading: true,
      dialog: false,
      agencyData: [],
      color: 'primary',
      resize: "lg4",
      menu: false,
      isAgencyDeleted: false,
      showMenuButton: false,
      agencyType: "Agency",
      providedAgencies: [],
      providerAgency: null,
      agencies: [{id: ''}],
      selectedAgency: null,
      dialog: false,
      loading: true,
      search: "",
      items: ["Account", "Agencies"],
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Logo",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Company",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "Approved",
          align: "center",
          sortable: false,
          value: "approved"
        },
        {
          text: "Disabled",
          align: "center",
          sortable: false,
          value: "approved"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
    this.getAgencies();
  },
  filters: {
    booleanify: function(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  methods: {
    alerting() {
      this.alert.status = !this.alert.status;
      setTimeout(() => {
        this.alert.status = !this.alert.status;
      }, 2500);
    },
    resizeCard(value) {
      this.resize = value;
    },
    closeDialog() {
      this.user = {
        password: '',
        confirm_password: ''
      }
      this.dialog = !this.dialog;
    },
    adjustBalance() {
      this.$router.push("/admin/agencies/balance/" + this.$route.params.id);
    },
    goBack() {
      this.$router.go(-1);
    },
    showAgency(item) {
      this.resize = "lg4";
      this.$router.push({ path: `/admin/agencies/subagency/show/${item.id}` });
      this.getData();
    },
    editAgency(item) {
      this.$router.push({ path: `/admin/agencies/edit/${item.id}` });
    },
    getData() {
      this.dataLoading = true;
      axios.get("/users/" + this.$route.params.id).then(res => {
        this.agencyData = res.data.user;
        this.showMenuButton = false;
        this.agencyType = "Agency";
        this.dataLoading = false;
        this.isAgencyDeleted = this.agencyData.is_deleted == 1 ? true : false
        this.color = this.isAgencyDeleted ? 'red' : 'primary';
        this.getProviderName(this.agencyData.provider_id);
        if (this.agencyData.is_provider === '1') {
          this.getProvided();
          this.resize = "lg10"
          this.agencyType = "Provider";
          this.showMenuButton = true;
          this.dataLoading = false;
        }
      });
    },
    getAgencies() {
      axios.get("/agencies").then(response => {
        this.agencies = response.data.users;
        this.dataLoading = false;
        this.loading = false;
        this.getProviderName(this.agencyData.provider_id);
      });
    },
    getProviderName(id) {
      return this.agencies.forEach(element => {
        if (element.id == id) {
          this.providerAgency = element.company + ' ID ' + element.id
        }
      });
    },
    addAgency(id) {
      axios
        .put("/users/" + id, {
          user: {
            provider_id: this.agencyData.id
          }
        })
        .then(res => {
          this.getProvided();
          this.alert.message = "Agency has been added to this provider.";
          this.alert.type = "success";
          this.alerting();
          this.selectedAgency = "";
        });
    },
    removeProvidedAgency(id) {
      axios
        .put("/users/" + id, {
          user: {
            provider_id: false
          }
        })
        .then(res => {
          this.getProvided();
          this.alert.message = "Agency has been removed from this provider.";
          this.alert.type = "success";
          this.alerting();
        });
    },
    getProvided() {
      axios
        .get("/users/" + this.$route.params.id + "/subagencies")
        .then(res => {
          this.providedAgencies = res.data.users;
        });
    },
    checkPassword() {
      axios.post("/me/verify", {
          password: this.user.password
        }
      )
      .then(res => {
          this.deleteItem();
        }).catch(res => {
          this.alert.message = "Could not delete agency. Please, check your password.";
          this.alert.type = "error";
          this.alerting();
        })
    },
    deleteItem() {
      axios.delete("/users/" + this.agencyData.id)
      .then(response => {
        this.alert.message = "Agency has been deleted";
        this.alert.type = "success";
        this.alerting();
        let vm = this;
        setTimeout(function(){ 
          vm.$router.push("/admin/agencies");
        }, 3000);
      });
    }
  }
};
</script>

<style scoped>
.expansion-panel__header {
  background-color: #28AFAF !important;
}
.alert {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Agencies/AgenciesShow.vue